import { IconBulb, IconChevronLeft } from "@tabler/icons-react";
import { useState } from "react";
import { Link } from "react-router-dom";
import CampaignChooser, { CampaignChoice } from "@/modules/smartAudience/CampaignChooser";
import classes from "./home.module.scss";
import { SectionGroup, SectionIcon } from "./sections";

export type Suggestion = {
  key: string;
  tone: SectionGroup;
  icon: SectionIcon;
  title: string;
  text: string;
  action: string;
  to: string;
  // The same audience as a discount SMS: tapping then asks «پیامک دعوت» or «با کد تخفیف».
  discountTo?: string;
};

type Props = {
  title: string;
  items: Suggestion[];
  // "list": quiet one-line rows (stylist home); default: swipeable cards.
  variant?: "cards" | "list";
  limit?: number;
};

export default function Suggestions({ title, items: all, variant = "cards", limit }: Props) {
  const items = limit ? all.slice(0, limit) : all;
  const [choice, setChoice] = useState<CampaignChoice>();
  if (!items.length) return null;
  const choose = (item: Suggestion) => setChoice({ title: item.title, smsTo: item.to, discountTo: item.discountTo! });
  const chooser = <CampaignChooser choice={choice} onClose={() => setChoice(undefined)} />;
  if (variant === "list")
    return (
      <section className={classes.section} aria-labelledby="home-suggestions-title">
        <div className={classes.sectionHead}>
          <h2 id="home-suggestions-title" className={classes.sectionTitle}>
            {title}
          </h2>
        </div>
        <div className={classes.card}>
          {items.map((item) => {
            const Icon = item.icon;
            return (
              <Link key={item.key} to={item.to} className={`${classes.suggestionRow} ${classes.tone}`} data-tone={item.tone}
                onClick={(event) => { if (item.discountTo) { event.preventDefault(); choose(item); } }}>
                <span className={classes.suggestionIcon}>
                  <Icon size={20} stroke={1.7} aria-hidden />
                </span>
                <span className={classes.suggestionText}>
                  <strong>{item.title}</strong>
                  <span>{item.action}</span>
                </span>
                <IconChevronLeft size={16} stroke={1.8} aria-hidden />
              </Link>
            );
          })}
        </div>
        {chooser}
      </section>
    );
  return (
    <section className={classes.suggestions} aria-labelledby="home-suggestions-title">
      <div className={classes.suggestionsHead}>
        <IconBulb size={20} stroke={1.7} aria-hidden />
        <h2 id="home-suggestions-title" className={classes.sectionTitle}>
          {title}
        </h2>
      </div>
      <div className={classes.scroller} data-single={items.length === 1 || undefined}>
        {items.map((item) => {
          const Icon = item.icon;
          return (
            <article key={item.key} className={`${classes.suggestion} ${classes.tone}`} data-tone={item.tone}>
              <div className={classes.suggestionBody}>
                <span className={classes.suggestionIcon}>
                  <Icon size={22} stroke={1.7} aria-hidden />
                </span>
                <div className={classes.suggestionText}>
                  <strong>{item.title}</strong>
                  <span>{item.text}</span>
                </div>
              </div>
              <Link to={item.to} className={classes.suggestionAction}
                onClick={(event) => { if (item.discountTo) { event.preventDefault(); choose(item); } }}>
                {item.action}
              </Link>
            </article>
          );
        })}
      </div>
      {chooser}
    </section>
  );
}
